/* eslint-disable max-len */
import type { FC } from 'react';

import type { BreakPatternProps } from './breakPatternTypes';

export const Skirt2Break: FC<BreakPatternProps> = props => {
  const { topColor, bottomColor, shadowColor, shadowOpacity = 0.2, ...rest } = props;
  return (
    <svg
      width="1440"
      height="96"
      viewBox="0 0 1440 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      role="presentation"
      {...rest}
    >
      <defs>
        <filter id="break-skirt2-shadow" x="0" y="0" width="100%" height="96">
          <feGaussianBlur stdDeviation="15" />
          <feComposite operator="out" in2="SourceGraphic" />
        </filter>
      </defs>

      {/* Top section */}
      <path
        d="M1440 0.0991211H0V50.1971C36.6091 43.6777 77.6641 37.7261 124.249 32.6745C310.648 12.4616 361 13.9746 528.797 31.5909C542.059 32.9831 555.219 35.2322 569.339 37.6453C599.237 42.755 633.435 48.5996 682 48.5996C731.565 48.3254 771.328 42.4257 813.924 36.1058C836.643 32.7351 860.166 29.2449 886.413 26.4248C944.864 20.7107 990.885 16.5365 1031.36 20.9347C1046.21 22.7434 1059.43 25.6192 1070.25 29.3933C1070.84 29.5968 1071.39 29.7913 1071.93 29.9783C1081.36 33.2595 1084.09 34.2084 1094.38 40.0996C1099.5 43.0274 1105.69 45.2946 1115.5 48.5996C1125.27 50.4244 1136.28 50.7567 1148.07 50.5944C1157.61 50.5266 1168.07 50.3572 1179.24 50.1765C1180.84 50.1505 1182.46 50.1243 1184.09 50.0982C1231.43 49.2382 1342.55 51.9494 1381.68 55.0925C1420.82 58.2357 1440 63.0996 1440 63.0996V0.0991211Z"
        fill={topColor}
      />

      {/* Bottom section */}
      <path
        d="M1440 79.2424V46.0986C1440 46.0986 1420.82 41.2347 1381.68 38.0915C1342.55 34.9484 1231.43 32.2372 1184.09 33.0972C1182.46 33.1233 1180.84 33.1495 1179.24 33.1755C1168.07 33.3562 1157.61 33.5256 1148.07 33.5935C1136.28 33.7557 1125.27 33.4234 1115.5 31.5986C1105.69 28.2936 1099.5 26.0264 1094.38 23.0986C1084.09 17.2074 1081.36 16.2586 1071.93 12.9773C1071.39 12.7904 1070.84 12.5958 1070.25 12.3924C1059.43 8.61827 1046.21 5.74244 1031.36 3.93377C990.885 -0.464426 944.864 3.70971 886.413 9.42386C860.166 12.244 836.643 15.7342 813.924 19.1048C771.328 25.4247 731.565 31.3244 682 31.5986C633.435 31.5986 599.237 25.754 569.339 20.6443C555.219 18.2313 542.059 15.9821 528.797 14.5899C361 -3.0264 310.648 -4.53937 124.249 15.6736C77.6641 20.7252 36.6091 26.6767 0 33.1961L4.37898e-05 79.2424H1440Z"
        fill={bottomColor}
        transform="translate(0 17)" // Move to bottom of the SVG container
      />

      {/* Drop shadow (same path as the top section with the filter applied) */}
      <path
        d="M1440 0.0991211H0V50.1971C36.6091 43.6777 77.6641 37.7261 124.249 32.6745C310.648 12.4616 361 13.9746 528.797 31.5909C542.059 32.9831 555.219 35.2322 569.339 37.6453C599.237 42.755 633.435 48.5996 682 48.5996C731.565 48.3254 771.328 42.4257 813.924 36.1058C836.643 32.7351 860.166 29.2449 886.413 26.4248C944.864 20.7107 990.885 16.5365 1031.36 20.9347C1046.21 22.7434 1059.43 25.6192 1070.25 29.3933C1070.84 29.5968 1071.39 29.7913 1071.93 29.9783C1081.36 33.2595 1084.09 34.2084 1094.38 40.0996C1099.5 43.0274 1105.69 45.2946 1115.5 48.5996C1125.27 50.4244 1136.28 50.7567 1148.07 50.5944C1157.61 50.5266 1168.07 50.3572 1179.24 50.1765C1180.84 50.1505 1182.46 50.1243 1184.09 50.0982C1231.43 49.2382 1342.55 51.9494 1381.68 55.0925C1420.82 58.2357 1440 63.0996 1440 63.0996V0.0991211Z"
        fill={shadowColor}
        opacity={shadowOpacity}
        filter="url(#break-skirt2-shadow)"
      />
    </svg>
  );
};
